<template>
    <div class="container-fluid fondo-color-01 p-5 text-white text-center">
		<p>Chetumal, Quintana Roo.</p>
	</div>
</template>
